module.exports = __webpack_public_path__ + "img/10.de9f3a2b.jpg";